<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
   <div>
       <Breadcrumbs main="Accesories" title="Existing Accessories" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list page-subtitle">
                        <div class="row">
                           <div class="col-md-10 d-flex">
                              <span style="font-size: 20px; font-weight: bolder;">Existing Accessories & Spare parts</span>
                           </div>
                           <div class="col-md-2">
                              <!-- <router-link :to="{ name: 'users.adduser' }" class="btn btn-primary">Add User</router-link> -->
                               <router-link :to="{ name: 'addaccessory' }" class="btn btn-primary">Add Accessory</router-link>
                           </div>
                        </div>
                     </div>

                     <div class="col-md-12 project-list filter-sort">
                        <div class="row">
                           <div class="col-md-9">
                              <label class="d-flex listing-length">
                                 <span>Show</span>
                                 <select class="form-select" v-model="listing_length" @change="fetchAccessories()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                 </select>
                                 <span>entries</span>
                              </label>
                           </div>
                                    
                           <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchAccessories()"/>
                           </div>
                        </div>
                     </div>

                        <div class="table-responsive product-table">
                           <table class="display" id="basic-1">
                              <thead>
                                 <tr>
                                    <th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                       aria-sort="ascending" aria-label="Name: activate to sort column descending"
                                       style="width: 415.266px;">Image</th>
                                       <th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                       aria-sort="ascending" aria-label="Name: activate to sort column descending"
                                       style="width: 275.266px;">Title</th>
                                    <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                       aria-label="Type: activate to sort column ascending"
                                       style="width: 337.797px;">Price</th>
                                    <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                       aria-label="Status: activate to sort column ascending"
                                       style="width: 215.797px;">Status</th>
                                    <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                       aria-label="Options: activate to sort column ascending"
                                       style="width: 515.266px;">Options</th>	
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr v-for="accessory in accessories" :key="accessory.id">
                                 <td><img v-if="accessory.image" :src="$image_url + accessory.image" alt="Image" class="avatar-60"></td>
                                 <td>{{accessory.title}}</td>
                                 <td>Rs. {{accessory.price}}</td>
                                 <td>
                                    
                                    <label v-if="accessory.status==0">Blocked</label>
                                    <label v-if="accessory.status==1">Active</label>
                                    <label v-if="accessory.status==2">Requested</label>
                                    <label v-if="accessory.status==3">Rejected</label>
                                    <label v-if="accessory.status==4">Sold</label>
                                    
                                 </td>
                                 <td>
                                    <router-link :to="{name: 'accessories.show', params: { id: accessory.id }}" class="btn btn-sm btn-primary mt-2 me-1" >View</router-link>


                                    <a href="#" class="btn btn-sm btn-primary mt-2 me-1" @click.prevent="setBackURL(accessory.id)">{{accessory.clicks}} Clicks <i class="fa fa-angle-double-right"></i></a>

                                    <router-link :to="{name: 'accessories.edit', params: { id: accessory.id }}" class="btn btn-sm btn-primary mt-2 me-1" >Edit</router-link>

                                    <a class="btn btn-success mt-2 me-1 btn-sm" @click="approveVehicle(accessory)" v-if="accessory.status==2">Approve</a> 

                                    <a class="btn btn-danger mt-2 me-1 btn-sm" @click="rejectVehicle(accessory)" v-if="accessory.status==2">Reject</a>                                     
                                    <a class="btn btn-danger mt-2 me-1 btn-sm" @click="deactivateVehicle(accessory)" v-if="accessory.status==1">Deactivate</a>

                                    <a class="btn btn-success mt-2 me-1 btn-sm" @click="activateVehicle(accessory)" v-if="accessory.status==0">Activate</a>                                   
                                 </td>
                              </tr>
                              </tbody>
                           </table>
                        </div>

                        <!----pagination starts --->
                        <nav aria-label="Page navigation" class="mt-2">                    
                           <ul class="pagination">
                              <li class="page-item" v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                                 <a class="page-link" href="#" @click.prevent="fetchAccessories(page.url + '&limit='+ listing_length + '&keyword=' + keyword )" tabindex="-1">
                                    <span v-if="index == 0">Prev</span>
                                    <span v-else-if="index == pagination.length-1">Next</span>
                                    <span v-else>{{page.label}}</span>
                                 </a>
                              </li>                        
                           </ul>
                        </nav>
                        <!----pagination ends --->    

                  </div>
               </div>
            </div>
         </div>
      </div>


     
  </div>
</template>


<script>
import '@/assets/css/custom.css';

export default {
   name:'ViewAccessories',
   data() {
      return {
         accessories: [],        
         pagination: {},
         
         edit: false,
         accessory_status: {
            id: "",
            status: ""
         },
         keyword: '',
         listing_length: 10,
         
         token: '',
         errors: {},
         active_page_url: null,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchAccessories();
   },

   methods: {      

      fetchAccessories(page_url=null) {
         let url = '/api/admin/accessories?limit=' + this.listing_length + '&keyword=' + this.keyword;
         page_url = page_url || url;  

         if(localStorage.back_url) {
            page_url = localStorage.back_url;              
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;      
            
         this.getToken();
         this.$axios
            .get(page_url,{headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;
               this.accessories = responseData.data;   
               console.log(this.accessories);            
               this.pagination = responseData.links
               
            })
            .catch(err => console.log(err));
      },   

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

      setBackURL(accessory_id) {
         localStorage.setItem('back_url', this.active_page_url);
         this.$router.push({ name: 'accessories.clicks', params: { id: accessory_id } });
      },
      
      approveVehicle(accessory) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to approve this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.accessory_status.id = accessory.id;
                  this.accessory_status.status = '1';
                  this.updateVehicleStatus(1);
					}
					
				});
      },
      rejectVehicle(accessory) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to reject this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                  this.accessory_status.id = accessory.id;
                  this.accessory_status.status = '3';
                  this.updateVehicleStatus(1);
					}
				});
      },
      activateVehicle(accessory) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                  this.accessory_status.id = accessory.id;
                  this.accessory_status.status = '1';
                  this.updateVehicleStatus();
					}
					
				});
      },
      deactivateVehicle(accessory) {
         let change_status = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this ad?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                  this.accessory_status.id = accessory.id;
                  this.accessory_status.status = '0';
                  this.updateVehicleStatus();
					}
				});
      },
      updateVehicleStatus(approval = 0) {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         if(approval) {
            url = '/api/admin/accessories/approve?accessory_id=';
         } else {
            url = '/api/admin/accessories/status?accessory_id=';
         }
         this.$axios
         .get(url + this.accessory_status.id + '&status=' + this.accessory_status.status, config)
         .then(response => {
            if(response.data.status) {
               this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            this.fetchAccessories(this.active_page_url);
         })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
               
          });
      },
   }   
}
</script>